import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertTriangle, ExternalLink } from "lucide-react";

export default function BulkFlagDetail({ open, onOpenChange, playerName, flag }) {
  if (!flag) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm max-w-xl" data-testid="bulk-flag-detail">
        <DialogHeader>
          <DialogTitle className="font-heading uppercase tracking-tight text-2xl">NB Nivå — Hockey.no treff</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="text-sm text-neutral-600">Spiller: <strong>{playerName}</strong></div>

          <div className="p-4 border-2 border-rose-500 bg-rose-50 rounded-sm flex items-start gap-3">
            <AlertTriangle className="w-6 h-6 text-rose-600 shrink-0 mt-0.5" />
            <div>
              <div className="font-heading text-lg font-black uppercase text-rose-700">Skal avvises</div>
              <div className="text-sm text-rose-700 mt-1">
                Registrert i {flag.hits} sesong{flag.hits === 1 ? "" : "er"} på øverste divisjon.
              </div>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest text-neutral-500 mb-2">Sesonger</div>
            <div className="flex flex-wrap gap-2">
              {flag.seasons.map((s) => (
                <span key={s} className="text-xs font-mono px-2 py-1 bg-neutral-100 border border-neutral-200 rounded-sm">{s}</span>
              ))}
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest text-neutral-500 mb-2">Lag</div>
            <div className="flex flex-wrap gap-2">
              {flag.teams.map((t) => (
                <span key={t} className="text-xs font-mono px-2 py-1 bg-neutral-100 border border-neutral-200 rounded-sm">{t}</span>
              ))}
            </div>
          </div>

          <div className="pt-3 border-t border-neutral-200 flex gap-4 text-xs text-neutral-500">
            <a href={`https://www.eliteprospects.com/search/player?q=${encodeURIComponent(playerName)}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-blue-600 hover:underline">
              <ExternalLink className="w-3 h-3 mr-1" />Elite Prospects
            </a>
            <a href={`https://live.hockey.no/`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-blue-600 hover:underline">
              <ExternalLink className="w-3 h-3 mr-1" />HockeyLive
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
